import { useSelector } from 'react-redux';

let urqlTenantCompanyId = null;

/** Sincronizado desde App cuando cambia la empresa seleccionada (urql exchange T4). */
export function setUrqlTenantCompanyId(companyId) {
  urqlTenantCompanyId = companyId || null;
}

export function getUrqlTenantCompanyId() {
  return urqlTenantCompanyId;
}

export function mergeTenantVariables(variables, companyIdOverride) {
  const base = variables && typeof variables === 'object' ? { ...variables } : {};
  const companyId = companyIdOverride ?? urqlTenantCompanyId;
  if (companyId != null && companyId !== '' && (base.companyId == null || base.companyId === '')) {
    base.companyId = companyId;
  }
  return base;
}

/** Empresa activa en el selector (A-02 tenant en queries ID-only). */
export function useSelectedCompanyId() {
  return useSelector((state) => state.companyList?.selectedCompany?.id);
}
